import { Chip, useTheme } from '@mui/material';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';

export const CustomChip = ({
  label,
  onClick,
  checked,
}: {
  label: string;
  onClick: () => void;
  checked: boolean;
}) => {
  const theme = useTheme();
  return (
    <Chip
      icon={checked ? <DynamicIcon name="done" /> : undefined}
      clickable
      label={label}
      onClick={onClick}
      color={checked ? 'secondary' : undefined}
      sx={{
        flex: '1 0 21%',
        margin: theme.spacing(0.5),
      }}
    />
  );
};
